// extracted by mini-css-extract-plugin
export default {"container":"Rating_container__H2nly","rating_icon":"Rating_rating_icon__7awK1"};